const formatter = typeof Intl !== "undefined" ? new Intl.NumberFormat("en-US", {}) : undefined

export const numberFormatter = (points: number) => {
  if (formatter) return formatter.format(points)
  return points.toLocaleString()
}
